import Vue from 'vue';
import Router from 'vue-router';
// const HelloWorld = resolve => require(['@/components/HelloWorld'], resolve);
const blockDetail = resolve => require(['@/pages/blockDetail'], resolve);
const marketCondition = resolve => require(['@/pages/marketCondition'], resolve);
const blockmap = resolve => require(['@/components/blockmaps/blockmap'], resolve);
const blockList = resolve => require(['@/components/blockmaps/blockList'], resolve);
const hotAnalysis = resolve => require(['@/pages/hotAnalysis'], resolve);
// import HelloWorld from "@/components/HelloWorld";
// import blockDetail from "@/pages/blockDetail";
// import marketCondition from "@/pages/marketCondition";
// import blockmap from "@/components/blockmaps/blockmap.vue";
// import blockList from "@/components/blockmaps/blockList.vue";
const lesChart = resolve => require(['@/components/LesChart/LesChart'], resolve);
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/marketCondition'
    },
    {
      path: '/blockDetail',
      name: 'blockDetail',
      component: blockDetail
    },
    {
      path: "/marketCondition",
      name: "marketCondition",
      component: marketCondition,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/hotAnalysis',
      name: 'hotAnalysis',
      component: hotAnalysis,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/lesChart',
      name: 'lesChart',
      component: lesChart
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js